import { request } from '../axios/request';

import {
  PACKAGING_PENDING,
  PACKAGING_REJECTED,
  PACKAGING_FULFILLED,
} from '../constants/packaging';

const OMS = require(`plugins/${process.env.REACT_APP_BRAND_CODE}/platformConfigs/integrationMaps/urls`);

const pending = () => ({
  type: PACKAGING_PENDING,
});

const rejected = (error) => ({
  type: PACKAGING_REJECTED,
  error,
});

const fulfilled = (response) => ({
  type: PACKAGING_FULFILLED,
  response,
});

export const packaging =
  (packageOrderId, selectedIds, actionParams) => (dispatch) => {
    const { id: commandId, source_state, destination_state } = actionParams;
    const url = OMS.OMS.PACKAGE_ORDER_DETAIL_COMMAND.replace(
      '{0}',
      packageOrderId
    );
    const data = {
      input_parameters: {
        package_items: selectedIds,
      },
      transition: commandId,
      source_state,
      destination_state,
    };

    dispatch(pending());

    request({
      method: 'POST',
      url,
      data,
    })
      .then((response) => {
        dispatch(fulfilled(response));
      })
      .catch((error) => {
        dispatch(rejected({ apiError: error }));
      });
  };



// WEBPACK FOOTER //
// ./src/actions/packaging.js